// Logo da ChessUp: apenas o leão (sem texto), com fundo transparente.
export default function Logo({ className = "", size = 40 }) {
  return (
    <div className={`flex items-center ${className}`} data-testid="chessup-logo">
      <img
        src="/chessup-logo.png"
        alt="ChessUp Academy"
        className="shrink-0 object-contain"
        style={{
          height: size,
          width: "auto",
          filter: "drop-shadow(0 0 14px rgba(212,175,55,0.35))",
        }}
      />
    </div>
  );
}
